import { HttpUrlEncodingCodec } from '@angular/common/http';
import { Component, Input, OnChanges } from '@angular/core';

import { AppInfoConfig, ProductService } from '@frontend/vanilla/core';
import { PageMatrixComponent } from '@frontend/vanilla/features/content';

import { Seobox } from './seobox.model';

@Component({
    selector: 'mc-seoboxes',
    templateUrl: 'seoboxes.component.html',
    imports: [PageMatrixComponent],
})
export class SeoboxesComponent implements OnChanges {
    @Input() seoboxes: Seobox[];
    currentProduct: string;
    constructor(
        private productService: ProductService,
        private appInfoConfig: AppInfoConfig,
    ) {}

    ngOnChanges(): void {
        this.currentProduct = this.productService.isSingleDomainApp ? this.productService.current.name : this.appInfoConfig?.product?.toLowerCase();

        if (this.seoboxes && this.seoboxes.length > 0) {
            const codec = new HttpUrlEncodingCodec();
            for (let i = 0; i < this.seoboxes.length; i++) {
                this.seoboxes[i].decodedPath = codec.decodeValue(this.seoboxes[i].path);
            }
        }
    }
}
